<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-edit-partial :domain="domain" />

                <h1 class="page-block__title | u-font-weight-normal">{{ trans('domain.edit-whois') }}</h1>

                <div class="page-block">
                    <div class="page-block__item-wrapper">
                        <form @submit.prevent="updateWhoisData" class="u-full-width">
                            <div class="layout">
                                <div class="layout__item u-1/2-desk">
                                    <text-input
                                        v-model="form.organization"
                                        :error="form.errors.first('organization')"
                                        :label="trans('domain.whois.labels.organization')"
                                        :name="trans('domain.whois.labels.organization')"
                                        class="u-full-width"
                                    />
                                </div>
                            </div>
                            <div class="layout">
                                <div class="layout__item u-1/2-desk">
                                    <text-input
                                        v-model="form.first_name"
                                        :error="form.errors.first('first_name')"
                                        :label="trans('domain.whois.labels.first_name')"
                                        :name="trans('domain.whois.labels.first_name')"
                                        class="u-full-width"
                                        required
                                    />
                                </div>
                                <!--
                             -->
                                <div class="layout__item u-1/2-desk">
                                    <text-input
                                        v-model="form.last_name"
                                        :error="form.errors.first('last_name')"
                                        :label="trans('domain.whois.labels.last_name')"
                                        :name="trans('domain.whois.labels.last_name')"
                                        class="u-full-width"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="layout">
                                <div class="layout__item u-1/2-desk">
                                    <text-input
                                        v-model="form.phone"
                                        :error="form.errors.first('phone')"
                                        :label="trans('domain.whois.labels.phone')"
                                        :name="trans('domain.whois.labels.phone')"
                                        class="u-full-width"
                                        required
                                    />
                                </div>
                                <!--
                             -->
                                <div class="layout__item u-1/2-desk">
                                    <text-input
                                        v-model="form.email"
                                        :error="form.errors.first('email')"
                                        :label="trans('domain.whois.labels.email')"
                                        name="email"
                                        class="u-full-width"
                                        type="email"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="layout">
                                <div class="layout__item u-1/2-desk">
                                    <text-input
                                        v-model="form.address.street"
                                        :error="form.errors.first('address.street')"
                                        :label="trans('domain.whois.labels.address.street')"
                                        name="street_name"
                                        class="u-full-width"
                                        required
                                    />
                                </div>
                                <!--
                             -->
                                <div class="layout__item u-1/2-desk">
                                    <text-input
                                        v-model="form.address.number"
                                        :error="form.errors.first('address.number')"
                                        :label="trans('domain.whois.labels.address.number')"
                                        name="street"
                                        class="u-full-width"
                                        required
                                    />
                                </div>
                            </div>
                            <div class="layout | u-margin-bottom-narrow">
                                <div class="layout__item u-1/2-desk">
                                    <div class="layout">
                                        <div class="layout__item u-1/3-desk">
                                            <text-input
                                                v-model="form.address.zipcode"
                                                :error="form.errors.first('address.zipcode')"
                                                :label="trans('domain.whois.labels.address.zipcode')"
                                                name="zipcode"
                                                class="u-full-width"
                                                required
                                            />
                                        </div>
                                        <div class="layout__item u-2/3-desk">
                                            <text-input
                                                v-model="form.address.city"
                                                :error="form.errors.first('address.city')"
                                                :label="trans('domain.whois.labels.address.city')"
                                                name="city"
                                                class="u-full-width"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <!--
                             -->
                                <div class="layout__item u-1/2-desk">
                                    <single-select
                                        dusk="country-component"
                                        v-model="form.address.country"
                                        :error="form.errors.first('address.country')"
                                        :label="trans('domain.whois.labels.address.country')"
                                        :options="countryValues"
                                        optionLabel="countryName"
                                        optionValue="countryCode"
                                        name="country"
                                        class="select--country u-full-width"
                                        required
                                    />
                                </div>
                            </div>

                            <div class="modal__nav">
                                <button class="btn btn--blue-record btn-ghost--dns" dusk="confirm-button" type="submit">
                                    {{ trans('action.set') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Api, apiMixin } from 'relapp-api';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { DomainOverview } from 'relapp-domain';
import { HeaderEditPartial, serviceMixin, servicesPageMixin, WhoisApi } from 'relapp-technical-management';
import { Way2Form } from 'relapp-way2forms';
import { EventBus } from 'relapp-event';
import { mapGetters } from 'vuex';

export default {
    components: {
        HeaderEditPartial,
        DomainOverview
    },
    mixins: [apiMixin, pageLoadingStatusMixin, serviceMixin, servicesPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'extension',
            form: new Way2Form({
                organization: null,
                first_name: null,
                last_name: null,
                gender: null,
                phone: null,
                email: null,
                address: {
                    street: null,
                    number: null,
                    zipcode: null,
                    city: null,
                    country: null,
                    suffix: null
                }
            }),
            countries: {}
        };
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.domain.title', { domain: this.domain })
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
        this.getWhoisData();
        this.getCountries();
    },
    computed: {
        ...mapGetters({
            whois: 'whois/whois'
        }),
        /**
         * Return the countries with a label and value.
         *
         * @return {array}
         */
        countryValues() {
            return Object.entries(this.countries).map(country => ({
                countryCode: country[0],
                countryName: country[1]
            }));
        }
    },
    watch: {
        whois: {
            /**
             * Watcher for the whois data.
             *
             * @param {object} newData
             */
            handler(newData) {
                this.form.populate({ ...newData[this.domain].owner });
            },
            deep: true
        }
    },
    methods: {
        /**
         * Get the whois data from the endpoint.
         */
        getWhoisData() {
            if (this.service) {
                WhoisApi.get(this.domain);
            }
        },
        /**
         * Call the endpoint to update the whois data.
         */
        updateWhoisData() {
            this.startLoading();
            WhoisApi.update(this.form.data(), this.routeParams)
                .then(() => {
                    this.$router.push({ name: 'domainOverview', params: { domain: this.domain } });

                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('services.confirmation.whois.message')
                    });
                })
                .catch(error => {
                    this.showValidationErrors(error, this.form);
                })
                .then(this.finishLoading);
        },
        /**
         * Get the countries.
         */
        getCountries() {
            Api.get('/countries/nl.json').then(response => {
                this.countries = response.data;
                this.form.populate({ ...this.whois[this.domain].owner });
            });
        }
    }
};
</script>
